import { render, staticRenderFns } from "./medal_list.vue?vue&type=template&id=6b90f9aa&scoped=true"
import script from "./medal_list.vue?vue&type=script&lang=ts"
export * from "./medal_list.vue?vue&type=script&lang=ts"
import style0 from "./medal_list.vue?vue&type=style&index=0&id=6b90f9aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b90f9aa",
  null
  
)

export default component.exports